export const TYPES_EVALUATIONS = {
  CLOZE: 'cloze',
  ESSAY: 'essay',
}
